import { useParams } from "react-router-dom";

const CaseStudySection = {
  phenom: {
    background_image: "Phenom_background_section",
    content2: "phenom is one of India’s leading managed office space providers, offering flexible, fully-equipped workspaces to startups, SMEs, and enterprises across multiple cities. As a fast-growing player in the coworking and commercial real estate space, Incuspaze handles a steady volume of new hires, vendor onboarding, and visitor traffic — making background and identity verification critical to their operations.",
  },
  goken:{
    background_image: "goken_background_section",
    content2: "goken is one of India’s leading managed office space providers, offering flexible, fully-equipped workspaces to startups, SMEs, and enterprises across multiple cities. As a fast-growing player in the coworking and commercial real estate space, Incuspaze handles a steady volume of new hires, vendor onboarding, and visitor traffic — making background and identity verification critical to their operations.",
  },
  ikf:{
    background_image: "ikf_background_section",
    content2: "ikf is one of India’s leading managed office space providers, offering flexible, fully-equipped workspaces to startups, SMEs, and enterprises across multiple cities. As a fast-growing player in the coworking and commercial real estate space, Incuspaze handles a steady volume of new hires, vendor onboarding, and visitor traffic — making background and identity verification critical to their operations.",
  },
  monitra:{
    background_image: "monitra_background_section",
    content2: "monitra is one of India’s leading managed office space providers, offering flexible, fully-equipped workspaces to startups, SMEs, and enterprises across multiple cities. As a fast-growing player in the coworking and commercial real estate space, Incuspaze handles a steady volume of new hires, vendor onboarding, and visitor traffic — making background and identity verification critical to their operations.",
  },
  incuspaze:{
    background_image: "Incuspaze_background_section",
     content2: "Incuspaze is one of India’s leading managed office space providers, offering flexible, fully-equipped workspaces to startups, SMEs, and enterprises across multiple cities. As a fast-growing player in the coworking and commercial real estate space, Incuspaze handles a steady volume of new hires, vendor onboarding, and visitor traffic — making background and identity verification critical to their operations.",
  },
}
export default function PhenomCaseStudySection() {
    const { companyName } = useParams(); // For Getting the Route Name
    const { background_image, content2 } = CaseStudySection[companyName]; // Render the content accourding to the param or company name
  return (
    <section className={`relative overflow-hidden ${background_image} mx-4` }>
      {/* Desktop and Tablet View */}
      <div className="flex w-full h-full flex-col lg:flex-row">
        {/* Text Box */}
        <div className="h-full rounded-lg flex flex-col items-center justify-center text-center p-6 abc">
          <h3 className="text-[43.26px] font-semibold leading-relaxed lg:text-white text-black mb-4">
            Client Background
          </h3>

          <p className="text-[26.9px] text-center lg:text-white text-black leading-relaxed">
            {content2}
          </p>
        </div>
      </div>
    </section>


  )
}
